<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Registro de vacinação"
    >
        <rkm-area
            no-margin-top
            title="Lista de aplicação / atualização"
        >
            <template v-slot:trailing>
                <rkm-button
                    @click="$refs.ModalAplicacao.open()"
                    color="primary"
                    small
                >
                    Nova aplicação
                </rkm-button>

                <rkm-button
                    @click="$refs.ModalAtualizacao.open()"
                    color="primary"
                    small
                >
                    Nova atualização
                </rkm-button>
            </template>

            <rkm-row>
                <rkm-col cols="12">
                    <rkm-table
                        :fields="fields.registro"
                        :items="registros"
                    >
                        <template v-slot:cell(registroTipo)="{ item }">
                            <template v-if="item.registroTipo === 'aplicacao'">Aplicação</template>
                            <template v-else>Atualização</template>
                        </template>

                        <template v-slot:cell(actions)="{ index, item }">
                            <template v-if="item.registroTipo === 'aplicacao'">
                                <rkm-button
                                    @click="$refs.ModalAplicacao.open(item, true)"
                                    small
                                    title="Visualizar"
                                >
                                    <rkm-icon icon="eye" />
                                </rkm-button>

                                <rkm-button
                                    :disabled="!!item.id"
                                    @click="$refs.ModalAplicacao.open(item, false, false, index)"
                                    color="primary"
                                    small
                                    title="Editar"
                                >
                                    <rkm-icon icon="pen" />
                                </rkm-button>

                                <rkm-button
                                    :disabled="!!item.id"
                                    @click="destroy(index)"
                                    color="danger"
                                    small
                                    title="Excluir"
                                >
                                    <rkm-icon icon="trash" />
                                </rkm-button>
                            </template>

                            <template v-else>
                                <rkm-button
                                    @click="$refs.ModalAtualizacao.open(item, true)"
                                    small
                                    title="Visualizar"
                                >
                                    <rkm-icon icon="eye" />
                                </rkm-button>

                                <rkm-button
                                    :disabled="!!item.id"
                                    @click="$refs.ModalAtualizacao.open(item, false, index)"
                                    color="primary"
                                    small
                                    title="Editar"
                                >
                                    <rkm-icon icon="pen" />
                                </rkm-button>

                                <rkm-button
                                    :disabled="!!item.id"
                                    @click="destroyAtualizacao(index)"
                                    color="danger"
                                    small
                                    title="Excluir"
                                >
                                    <rkm-icon icon="trash" />
                                </rkm-button>
                            </template>
                        </template>
                    </rkm-table>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <ModalAplicacao
            :additionals="data.additionals"
            :form="data.form"
            :id="data.pacienteId"
            :model="model"
            disable-aplicador
            disable-data
            ref="ModalAplicacao"
        />

        <ModalAtualizacao
            :additionals="data.additionals"
            :form="data.form"
            :id="data.pacienteId"
            :model="model"
            disable-aplicador
            ref="ModalAtualizacao"
        />

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Cancelar
            </rkm-button>

            <rkm-button
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import ModalAplicacao from '@/components/imunizacao/registro-vacinacao/components/aplicacao/Modal'
import ModalAtualizacao from '@/components/imunizacao/registro-vacinacao/components/atualizacao/Modal'

// Enums.
import parametrizacaoDescricaoVacina from '@/enums/imunizacao/parametrizacaoDescricaoVacina'

// Mixins.
import { object } from '@/mixins'

export default {
    components: {
        ModalAplicacao,
        ModalAtualizacao,
    },
    computed: {
        model() {

            const model = this.clone(this.data.model)

            model.registros = this.registros

            return model
        },
        fields() {
            const commonFields = []

            switch (this.data.additionals.parametrizacao.parametrizacaoDescricaoVacinaId) {
                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA:
                    commonFields.push({ key: 'vacinaAbreviacao', label: 'Abreviação da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA:
                    commonFields.push({ key: 'vacinaSigla', label: 'Sigla da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO:
                    commonFields.push({ key: 'vacinaSiglaNome', label: 'Sigla e nome da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA:
                    commonFields.push({ key: 'vacinaSiglaAbreviacao', label: 'Sigla e abreviação da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA_DESCRICAO:
                    commonFields.push({ key: 'vacinaAbreviacaoNome', label: 'Abreviação e nome da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA_DESCRICAO:
                    commonFields.push({ key: 'vacinaSiglaAbreviacaoNome', label: 'Sigla, abreviação e nome da vacina' })
                    break;

                default:
                    commonFields.push({ key: 'vacinaNome', label: 'Nome da vacina' })
                    break;
            }

            return {
                registro: [
                    { key: 'registroTipo', label: 'Tipo de registro' },
                    ...commonFields,
                    { key: 'doseNome', label: 'Dose' },
                    { key: 'dataRegistro', label: 'Data' },
                    { key: 'unidadeNomeFantasia', label: 'Unidade' },
                    { key: 'salaVacinacaoNome', label: 'Sala de vacinação' },
                    { key: 'observacao', label: 'Observação' },
                    { class: 'col-min text-center', key: 'actions', label: 'Ações' },
                ],
            }
        },
    },
    data: () => ({
        enums: { parametrizacaoDescricaoVacina },
        registros: [],
    }),
    methods: {
        open() {

            this.registros = this.clone(this.data.model.registros)

            this.$refs.RkmModal.show()
        },
        save() {

            this.data.model.registros = this.clone(this.registros)

            this.$refs.RkmModal.hide()
        },
        destroy(index) {

            this.showDeleteConfirmation(
                'Deseja realmente excluir o registro?',
                async () => this.registros.splice(index, 1)
            )
        },
        destroyAtualizacao(index) {

            this.showDeleteConfirmation(
                'Deseja realmente excluir a atualização?',
                async () => this.registros.splice(index, 1)
            )
        },
    },
    mixins: [object],
    props: {
        data: { type: Object, required: true }
    },
}
</script>